document.addEventListener('DOMContentLoaded', () => {
  console.log('🛒 [Cart.js] Loaded');

  // Open cart drawer when clicking the cart icon
  document.querySelectorAll('[data-action="open-cart"]').forEach(icon => {
    icon.addEventListener('click', (e) => {
      console.log('🛍 [Cart.js] Cart icon clicked:', e.target);
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        console.log('✅ [Cart.js] Opening cart drawer...');
        cartDrawer.open();
      } else {
        console.error('❌ [Cart.js] cart-drawer not found.');
      }
    });
  });

  // Handle Add to Cart Form
  // document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  //   form.addEventListener('submit', async (e) => {
  //     e.preventDefault();

  //     console.log('🚀 [Cart.js] Form submitted:', form);

  //     const formData = new FormData(form);
  //     try {
  //       console.log('📡 [Cart.js] Sending request to /cart/add.js...');
  //       const response = await fetch('/cart/add.js', {
  //         method: 'POST',
  //         headers: { 'Accept': 'application/json' },
  //         body: formData
  //       });

  //       if (!response.ok) {
  //         console.error('❌ [Cart.js] Failed to add item to cart.');
  //         return;
  //       }

  //       const result = await response.json();
  //       console.log('🛒 [Cart.js] Item added to cart:', result);

  //       // Dispatch cart updated event
  //       console.log('📢 [Cart.js] Dispatching cart:updated event...');
  //       document.dispatchEvent(new CustomEvent('cart:updated'));

  //       // Ensure cart drawer updates immediately
  //       const cartDrawer = document.querySelector('cart-drawer');
  //       if (cartDrawer) {
  //         console.log('✅ [Cart.js] Updating cart drawer...');
  //         await cartDrawer.updateCartContents();
  //         cartDrawer.open();
  //       } else {
  //         console.error('❌ [Cart.js] cart-drawer not found.');
  //       }

  //     } catch (error) {
  //       console.error('❌ [Cart.js] Cart error:', error);
  //     }
  //   });
  // });

  // Listen for cart:updated event and refresh drawer content
  // document.addEventListener('cart:updated', async () => {
  //   console.log('📢 [Cart.js] cart:updated event triggered! Fetching cart content...');

  //   try {
  //     const response = await fetch('/cart.js');
  //     const cartData = await response.json();
  //     console.log("📦 [Cart.js] Received cart JSON:", cartData);

  //     if (cartData.items.length === 0) {
  //       console.warn("⚠️ [Cart.js] No cart content found.");
  //       document.querySelector('cart-drawer').classList.add('is-empty');
  //       return;
  //     }

  //     const cartDrawer = document.querySelector('cart-drawer');
  //     if (cartDrawer) {
  //       console.log('✅ [Cart.js] Updating cart drawer...');
  //       await cartDrawer.updateCartContents();
  //     }
  //   } catch (error) {
  //     console.error('❌ [Cart.js] Error fetching cart:', error);
  //   }
  // });
});

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          console.log(elementToReplace)
          console.log(this.getSectionInnerHTML(parsedState.sections[section.section], section.selector))
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
}
